import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

export const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    borderRadius: "50px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    backgroundColor: "#F95919",
    color: "#fff",
    width: "150px",
    boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
    fontSize: "14px",
    height: "40px",
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
    [theme.breakpoints.down("xs")]: {
      width: 260,
      marginTop: "20px",
    },
  },
  drop: {
    border: "2px solid #e45826",
    borderRadius: 60,
  },
  dialog: {
    borderRadius: 60,
  },
  res: {
    marginTop: 10,
    width: 450,
    [theme.breakpoints.down("xs")]: {
      marginTop: 10,
      width: 300,
    },
  },
}));

export const CssTextField = withStyles({
  root: {
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: " 0px 10px",
      height: "40px",
    },
    "& label.Mui-focused": {
      color: "#e45826",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#f95919",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #e45826",
        borderRadius: 50,
      },
      "&:hover fieldset": {
        borderColor: "#f95919",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f95919",
      },
    },
  },
})(TextField);
